<template>
	<div>
		<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="true"
			staticMode="true"
		>
		</TopAppBar>
		<div class="d-flex flex-column">
			<TopAppBarDrawer></TopAppBarDrawer>
			<main class="main-wrapper flex-grow-1">
						<div class="d-flex align-items-center bg-white">
							<div class="t-headline11 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 ">
								{{$t('1730')}}
							</div>
						</div>
						<div class="divider"></div>
						<div class="container container--narrow pdt-50">
							<div class="t-headline11 t-color-headlineBlack t-center font-m">
								{{ $t('1731') }}
							</div>
							<div class="t-body1 t-color-iconInactive t-center font-r mgt-8">
								{{ $t('1732', {str: '8.0.1'}) }}
							</div>
							<div class="mgt-50 mgb-50 t-center">
								<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8">
									<div class="mdc-button__ripple"></div>
									<span class="mdc-button__label t-body2 font-r">{{ $t('1735') }}</span>
								</button>
							</div>
						</div>
		</main>
		</div>
	</div>
</template>

<style scoped>

</style>

<script>
import TopAppBar from '@/components/TopAppBar.vue'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import {topAppBarMixin} from '@/mixins/topAppBar.js'

export default {

	data() {
		return {
		title:localStorage.getItem('brandName')
		}
	},
	components: {
		TopAppBar,
		TopAppBarDrawer,
	},

	mixins: [topAppBarMixin],
}
</script>
